namespace advisorop.services {
    `use strict`;
    
    export class InvestorService {

        // item and level from Household Summary Grid 
        selHDItem: any;
        selHDLevel: string = "";

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        getInvestor(): ng.IHttpPromise<domains.IInvestor> {
            return this.$http.get(`/api/investor`);
        };
        getAccounts(accountStatus: number, showClosedAccounts: boolean): ng.IHttpPromise<Array<domains.IAccount>> {
            return this.$http.get(`/api/investor/accounts/${accountStatus}/${showClosedAccounts}`);
        };
        getHouseholds(withAum: boolean): ng.IHttpPromise<domains.IHousehold[]> {
            //return this.$http.get(`/api/investor/households/${withAum}`);
            return this.$http.get(`/api/investor/households?withAum=${withAum}`);
        };
        getHousehold(householdId: number): ng.IHttpPromise<domains.IHousehold> {
            return this.$http.get(`/api/investor/household/${householdId}`);
        };
        getAccountDocumentation(accountId: number, documentType: number = null, includeHistory: boolean = false, showDeletedFiles: boolean = false): ng.IHttpPromise<any[]> {
            return this.$http.get(`api/investor/dms/accountdocumentation/${accountId}/${documentType}/${includeHistory}/${showDeletedFiles}`);
        };
        getInvestorDocumentation(documentType: number = null, includeHistory: boolean = false, showDeletedFiles: boolean = false): ng.IHttpPromise<any[]> {
            return this.$http.get(`api/investor/dms/${documentType}/${includeHistory}/${showDeletedFiles}`);
        };
        getPerformanceOverview(householdId: number) {
            return this.$http.get(`api/investor/hhperformanceoverview/${householdId}`);
        }


        getMarketValues(): ng.IHttpPromise<domains.IChartDataSource> {
            return this.$http.get(`/api/investor/getmarketvalues`);
        };

        // moved to HouseholdApi
        //getHDAccounts(groupType: number, householdId?: number, showClosedInactive?: boolean): ng.IHttpPromise<any> {
        //    if (householdId)
        //        return this.$http.get(`api/household/${householdId}/accountgroups/${groupType}/summary?showClosedInactive=${showClosedInactive}`);
        //    else
        //        return this.$http.get(`api/investor/hdaccounts/${groupType}/${showClosedInactive}`);
        //};

        getHoldingsByHhCharts(): ng.IHttpPromise<domains.IChartDataSource[]> {
            return this.$http.get(`/api/investor/holdingsbyhh`);
        };
        
        // moved to HouseholdApi
        //getHDCharts(householdId: number, groupType: number, chartGroup: string,
        //    groupId: number, accountId: number, sleeveId: number,
        //    showClosedInactive?: boolean, hideSleeves?: boolean): ng.IHttpPromise<domains.IChartDataSource[]> {
        //    return this.$http.get(`api/investor/hhdashboardcharts/${householdId}/${groupType}/${chartGroup}/${groupId}/${accountId}/${sleeveId}/${showClosedInactive}/${hideSleeves}`);
        //};

        // RTG dashboard

        // moved to AccountGroupApi.ts
        //getRtgPerformanceDetails(rtgId: number): ng.IHttpPromise<domains.IAccountGroup> {
        //    return this.$http.get(`api/investor/getaccountgroupperformancedetails/${rtgId}`);
        //};

        getRtgPerformanceDetailsP2P(rtgId: number, fromDate: Date, toDate: Date): ng.IHttpPromise<any> {
            const req: domains.IPerformanceDetailsP2PRequest = {
                fromDate: fromDate,
                toDate: toDate,
                groupId: rtgId
            };
            return this.$http.post(`api/investor/getaccountgroupperformancedetailsP2P`, req);
        };

        // moved to AccountGroupApi.ts
        //getAccountGroupAccounts(groupId?: number, showClosedInactive?: boolean): ng.IHttpPromise<any> {
        //    return this.$http.get(`api/investor/getaccountgroupaccounts/${groupId}/${showClosedInactive}`);
        //};

        getInvestorAdvisor(): ng.IHttpPromise<domains.IAdvisor> {
            return this.$http.get(`api/investor/advisor`);
        };
    }
    angular.module(Constants.ADVOP_SERVICES).service(`investorService`, InvestorService);
} 